// src/init.ts
import setupChunkErrorHandler from './utils/setupChunkErrorHandler'

// Immediately execute chunk error handler before anything else
setupChunkErrorHandler()
